// The wrong-password message points at the recovery link the person can actually see on that screen.
export const STAFF_RECOVERY_LINK = "Can't sign in / Forgot password?";
export const SIMPLE_RECOVERY_LINK = 'Forgot password?';
export function invalidSignInMessage(recoveryLink = STAFF_RECOVERY_LINK) {
    return `That email or password isn't correct. Try again, or use \u201c${recoveryLink}\u201d.`;
}
export const INVALID_SIGN_IN_MESSAGE = invalidSignInMessage();
export const SIGN_IN_SERVICE_ERROR_MESSAGE = "We couldn't sign you in right now. Check your connection and try again.";

export function isInvalidSignInCredentials(error) {
    return error?.code === 'invalid_credentials'
        || error?.code === 'invalid_grant'
        || /invalid (login )?credentials/i.test(error?.message || '');
}

export function signInErrorMessage(error, { recoveryLink = STAFF_RECOVERY_LINK } = {}) {
    if (isInvalidSignInCredentials(error)) return invalidSignInMessage(recoveryLink);
    return SIGN_IN_SERVICE_ERROR_MESSAGE;
}
